module.exports = __webpack_public_path__ + "oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.ece6673e477b4d7aca12.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.woff2
// module id = ../../../../../src/assets/fonts/font-google/oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.woff2
// module chunks = 40